import styled from 'styled-components';
import { Theme, Box } from '@material-ui/core';
import { TreeView, TreeItem, TreeItemProps } from '@material-ui/lab';
import CloseTreeIcon from '../../../../../../icons/CloseTree';
import OpenTreeIcon from '../../../../../../icons/OpenTree';

const getDisabled = (props: unknown) => {
  return Boolean((props as any)['disabled']);
};

const theme = (props: any) => {
  return props.theme as Theme;
}
export const CloseIcon = styled(CloseTreeIcon)(props => ({

})) as typeof CloseTreeIcon;

export const OpenIcon = styled(OpenTreeIcon)(props => ({

})) as typeof OpenTreeIcon;

export const StyledTree = styled(TreeView)(props => ({
  marginBottom: theme(props).spacing(1),
})) as typeof TreeView;

const StyledTreeBase = styled(TreeItem)(props => ({
  "& .content:hover": {
    background: "rgba(51, 51, 51, 0.05)",
    // transition: 'background .5s',
  },
  "&.selected": {
    "& > .content": {
      background: "rgba(101, 172, 30, 0.2)",

      "& > .label": {
        background: "none !important",
        color: "#65AC1E",
      }
    },
  },
  "& .content": {
    // transition: 'background .5s',
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  "& .label": {
    color: getDisabled(props) ? "#b6b6b6" : "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  }
})) as React.FC<TreeItemProps & { disabled?: boolean }>;

export const StyledTreeItem = styled(StyledTreeBase)(props => ({
  marginBottom: '2px',

})) as typeof StyledTreeBase;

export const StyledTreeItemParent = styled(StyledTreeBase)(props => ({

})) as typeof StyledTreeBase;